




























import OrgService from '@/api/org.service';
import { SET_ORG_DETAILS } from '@/store/mutation-types';
import { IUser, IPrecisionRetryConfig } from '@/store/types';
import Vue from 'vue';

export default Vue.extend({
  name: 'SettingsPrecisionRetries',
  data() {
    return {
      loading: false,
    };
  },
  computed: {
    org() {
      return this.$store.state.org;
    },
    smartRetries(): IPrecisionRetryConfig {
      return this.org?.smartRetries;
    },
    precisionRetriesEnabled(): boolean {
      return this.smartRetries.enabled || false;
    },
    toggleDisabled(): boolean {
      return !this.$store.getters.isAdmin;
    },
  },
  methods: {
    async togglePrecisionRetries() {
      const initialValue = this.precisionRetriesEnabled;
      this.loading = true;
      const enabled = !initialValue;
      const smartRetries = { ...this.smartRetries, enabled };
      this.$store.commit(SET_ORG_DETAILS, { smartRetries });
      try {
        await OrgService.update(this.$store.state.org._id, { smartRetries });
        // @ts-ignore
        this.$notify({ title: `Precision Retries ${enabled ? 'Enabled' : 'Disabled'}`, type: 'success' });
      } catch (e) {
        console.log(e);
        // @ts-ignore
        this.$notify({ title: `Failed to ${enabled ? 'Enable' : 'Disable'} Precision Retries`, type: 'error' });
      } finally {
        this.loading = false;
      }
    },
  },
});
